export const Input = ({ errorMessage, ...props }) => {
  return (
    <div className="input-wrapper">
      <input {...props} className={`${!!errorMessage ? "has-error" : ""}`} />
      {errorMessage && <p>{errorMessage}</p>}
    </div>
  );
};
